import { Outlet } from "react-router-dom";
import { SectionView } from "../components/templates/SectionView.tsx";
import { VaultGrid } from "../components/organisms/VaultGrid.tsx";
import { useLegacyVaultRedirect } from "../lib/legacyRedirect.tsx";

export function VaultPage() {
  useLegacyVaultRedirect();
  return (
    <SectionView
      ariaLabel="Vault"
      title="The Vault"
      sub="Curated resources — my own markdown notes alongside tools and reads worth keeping. Notes open right here on the desk."
    >
      <VaultGrid />
      <Outlet />
    </SectionView>
  );
}
